import axios from "axios";
import api from "../../lib/api/api";
export const ADD_CONTENT_REQUEST = "ADD_CONTENT_REQUEST";
export const ADD_CONTENT_SUCCESS = "ADD_CONTENT_SUCCESS";
export const ADD_CONTENT_FAILURE = "ADD_CONTENT_FAILURE";

export const FETCH_CONTENT_REQUEST = "FETCH_CONTENT_REQUEST";
export const FETCH_CONTENT_SUCCESS = "FETCH_CONTENT_SUCCESS";
export const FETCH_CONTENT_FAILURE = "FETCH_CONTENT_FAILURE";

export const addContentAction = (formData) => async (dispatch) => {
  dispatch({ type: ADD_CONTENT_REQUEST });
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/teachers/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    dispatch({ type: ADD_CONTENT_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: ADD_CONTENT_FAILURE,
      payload: error.response?.data?.message || "Failed to upload content",
    });
  }
};

export const fetchContentAction =
  (lessonId, teacherCourseId) => async (dispatch) => {
    dispatch({ type: FETCH_CONTENT_REQUEST });
    try {
      const response = await api.get(
        `/teachers/lesson/${lessonId}/course/${teacherCourseId}`
      );
      dispatch({ type: FETCH_CONTENT_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({
        type: FETCH_CONTENT_FAILURE,
        payload: error.response?.data?.message || "Failed to fetch content",
      });
    }
  };

export const CLEAR_CONTENT = "CLEAR_CONTENT";

export const clearContentAction = () => ({
  type: CLEAR_CONTENT,
});
